import { useContext, useState } from 'react';

import { ApplicationContext } from '../../../../../../shared/source/context/context';
import { useTablePagination } from '../../../common/data-grids/common/use-table-pagination';
import { SkillsDataGrid } from '../../../common/data-grids/skills/SkillsDataGrid';
import { useSkillsColumns } from '../../../common/data-grids/skills/use-skills-columns';
import { defaultPagination } from '../../../global-search/use-global-search-table-params';
import { useGlobalSearchSkillsResultQuery } from '../../../query-hooks/global-search/skills';

import type { SkillRow } from '../../../common/data-grids/skills/SkillsDataGrid';
import type { GridSortModel } from '@mui/x-data-grid-pro';
import type { FunctionComponent } from 'react';

type SkillsSearchTermTableProps = {
    readonly searchTerm: string;
};

export const SkillsSearchTermTable: FunctionComponent<SkillsSearchTermTableProps> = ({ searchTerm }) => {
    const { translate } = useContext(ApplicationContext);

    const { paginationModel, setPaginationModel } = useTablePagination();

    const [sortModel, setSortModel] = useState<GridSortModel>([]);

    const { data, isFetching, isPending } = useGlobalSearchSkillsResultQuery({
        pagination: { page: paginationModel.page, size: paginationModel.pageSize },
        searchTerm,
        sortedFields: sortModel.map((item) => ({
            direction: item.sort ?? 'asc',
            field: item.field,
        })),
    });

    const columns = useSkillsColumns({ sortable: true });

    const skills = data?.data ?? [];
    const pagination = data?.pagination ?? defaultPagination;

    const rows: readonly SkillRow[] = skills.map((skill) => ({
        area: 'related',
        skill,
        type: 'skill',
    }));

    const noDataMessage = translate('pages.global-search.no-data.skills');

    return (
        <SkillsDataGrid
            columns={columns}
            isFetching={isFetching}
            isPending={isPending}
            noDataMessage={noDataMessage}
            paginationModel={paginationModel}
            rowCount={pagination.count}
            rows={rows}
            sortModel={sortModel}
            onPaginationModelChange={setPaginationModel}
            onSortModelChange={setSortModel}
        />
    );
};
